// export const decrypt = (
//   message: TMessage,
//   userKeypair: KeyPair,
//   userAddress: string
// ) => {
//   const targetPubKeyStr =
//     message.fromAddress === userAddress
//       ? message.toPubKeyBase64
//       : message.fromPubKeyBase64;
//   const targetPubKey = new Uint8Array(Buffer.from(targetPubKeyStr, "base64"));
//   try {
//     const decryptedMsg = userKeypair.decrypt(
//       targetPubKey,
//       message.messageText
//     ) as string;
//     if (hashFromString(decryptedMsg) === message.msgSha256Base64)
//       return decryptedMsg;
//   } catch (e) {
//     console.log("real reason: ", e);
//   }
//   throw new Error("Decrypt fail");
// };
// export const hashFromString = (msg: string) => {
//   var hash = CryptoJS.SHA256(msg);
//   var base64 = CryptoJS.enc.Base64.stringify(hash);
//   return base64;
// };
// export const generateMessage = (
//   fromAddress: string,
//   toAddress: string,
//   plaintextMessage: string,
//   userKeypair: KeyPair,
//   toPubKeyUint8: Uint8Array
// ) => {
//   // TODO: do some error handle of this.encrypt
//   const messageText = encrypt(plaintextMessage, userKeypair, toPubKeyUint8);
//   const message: TMessage = {
//     messageText,
//     id: uuidv4(),
//     fromAddress: fromAddress,
//     toAddress: toAddress,
//     sended: false,
//     msgSha256Base64: hashFromString(plaintextMessage),
//     fromPubKeyBase64: Buffer.from(userKeypair.get().public!).toString("base64"),
//     toPubKeyBase64: Buffer.from(toPubKeyUint8).toString("base64"),
//     cid: "",
//     plaintextMessage: "",
//   };
//   return message;
// };
// export const encrypt = (
//   plaintextMessage: string,
//   userKeypair: KeyPair,
//   toPubKeyUint8: Uint8Array
// ) => {
//   try {
//     return userKeypair.encrypt(toPubKeyUint8, plaintextMessage, true) as string;
//   } catch (e) {
//     throw new Error("Encrypt fail");
//   }
// };
export const parseMessage = (message) => {
    return {
        id: message.id,
        createdAt: message.created_at,
        fromAddress: message.from_address,
        toAddress: message.to_address,
        messageText: message.message_text,
        sended: message.sended,
        msgSha256Base64: message.msg_sha256_base64,
        fromPubKeyBase64: message.from_pub_key_base64,
        toPubKeyBase64: message.to_pub_key_base64,
        cid: message.cid,
        plaintextMessage: "",
    };
};
//# sourceMappingURL=dm.utils.js.map